export class FactorGpiBody {
  IsExcluded: boolean;
  Gpis: string[];
}
